import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import {
  Box, Button, Paper, Stack, Typography, Chip, TextField,
  Table, TableBody, TableCell, TableHead, TableRow, IconButton,
} from "@mui/material";
import EditIcon from "@mui/icons-material/Edit";
import BlockIcon from "@mui/icons-material/Block";
import KeyIcon from "@mui/icons-material/Key";
import Swal from "sweetalert2";
import { listarUsuarios, excluirUsuario, resetarSenha } from "../../services/usuarioService";

export default function UsuarioList() {
  const navigate = useNavigate();
  const [usuarios, setUsuarios] = useState([]);
  const [termo, setTermo] = useState("");

  const carregar = async () => {
    try {
      const { data } = await listarUsuarios(termo);
      setUsuarios(data);
    } catch (e) {
      Swal.fire("Erro", e?.response?.data || e.message, "error");
    }
  };

  useEffect(() => {
    carregar();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const desativar = async (id) => {
    const r = await Swal.fire({
      title: "Desativar usuário?", icon: "warning", showCancelButton: true,
      confirmButtonText: "Desativar", cancelButtonText: "Cancelar",
    });
    if (!r.isConfirmed) return;
    await excluirUsuario(id);
    carregar();
  };

  const reset = async (u) => {
    const { value: senha } = await Swal.fire({
      title: `Nova senha para ${u.Nome}`,
      input: "password", inputPlaceholder: "Digite a nova senha",
      showCancelButton: true, confirmButtonText: "Redefinir", cancelButtonText: "Cancelar",
    });
    if (!senha) return;
    await resetarSenha(u.Codigo, senha);
    Swal.fire("Pronto", "Senha redefinida.", "success");
    carregar();
  };

  return (
    <Box>
      <Stack direction="row" justifyContent="space-between" alignItems="center" mb={2}>
        <Typography variant="h5">Usuários</Typography>
        <Button variant="contained" onClick={() => navigate("/usuarios/novo")}>Novo usuário</Button>
      </Stack>

      <Stack direction="row" spacing={1} mb={2}>
        <TextField size="small" label="Buscar" value={termo} sx={{ width: 320 }}
          onChange={(e) => setTermo(e.target.value)}
          onKeyDown={(e) => e.key === "Enter" && carregar()} />
        <Button variant="outlined" onClick={carregar}>Buscar</Button>
      </Stack>

      <Paper>
        <Table size="small">
          <TableHead>
            <TableRow>
              <TableCell>Nome</TableCell>
              <TableCell>Login</TableCell>
              <TableCell>E-mail</TableCell>
              <TableCell align="center">Senha</TableCell>
              <TableCell align="center">Status</TableCell>
              <TableCell align="center">Ações</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {usuarios.map((u) => (
              <TableRow key={u.Codigo} hover>
                <TableCell>{u.Nome}</TableCell>
                <TableCell>{u.Login}</TableCell>
                <TableCell>{u.Email}</TableCell>
                <TableCell align="center">
                  <Chip size="small" label={u.TemSenha ? "Definida" : "Pendente"}
                    color={u.TemSenha ? "success" : "warning"} />
                </TableCell>
                <TableCell align="center">
                  <Chip size="small" label={u.Ativo ? "Ativo" : "Inativo"}
                    color={u.Ativo ? "success" : "default"} />
                </TableCell>
                <TableCell align="center">
                  <IconButton size="small" onClick={() => navigate(`/usuarios/${u.Codigo}`)}>
                    <EditIcon fontSize="small" />
                  </IconButton>
                  <IconButton size="small" title="Redefinir senha" onClick={() => reset(u)}>
                    <KeyIcon fontSize="small" />
                  </IconButton>
                  {u.Ativo && (
                    <IconButton size="small" color="error" onClick={() => desativar(u.Codigo)}>
                      <BlockIcon fontSize="small" />
                    </IconButton>
                  )}
                </TableCell>
              </TableRow>
            ))}
            {usuarios.length === 0 && (
              <TableRow><TableCell colSpan={6} align="center">Nenhum usuário.</TableCell></TableRow>
            )}
          </TableBody>
        </Table>
      </Paper>
    </Box>
  );
}
